import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { RichLink } from './richLink';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatSelect, MatOption } from '@angular/material/select';
import { required } from '../../../../../../../shared/utils';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { SelectMediaComponent } from '../../../../select-media/select-media.component';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'richLink';

@Component({
    selector: 'app-rich-link',
    templateUrl: './rich-link.component.html',
    styleUrls: ['./rich-link.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, SelectMediaComponent, ClickatellFormValidationComponent, ActiveFormDirective, MatButtonToggleGroup, MatButtonToggle, MatSelect, MatOption, CMSComponent, NextSelectorComponent]
})
export class RichLinkComponent extends NodeBuilder implements OnInit {

  richLinkForm: UntypedFormGroup = undefined;
  newStep = undefined;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.richLinkForm = RichLink.toForm(stepData, this.canEdit);

    if (this.richLinkForm.get('next').value === newStepValue) {
      this.newStep = 'step' + this.getNextStep();
      this.richLinkForm.get('next').setValue(this.newStep);
    }

    this.updateValidators(this.richLinkForm.get('previewType').value);
    this.setupHeaderValidation();
  }

  private setupHeaderValidation(): void {
    // Handle initial conflicts - if both are populated, prioritize media header
    const menuHeader = this.richLinkForm.get('menuHeader');
    const menuMediaLink = this.richLinkForm.get('menuMediaLink');
    const menuMediaType = this.richLinkForm.get('menuMediaType');

    if (menuHeader.value && menuMediaLink.value) {
      menuHeader.setValue('');
    }

    // Listen for changes to menuHeader
    menuHeader.valueChanges.subscribe(value => {
      if (value) {
        // Clear menu media fields when header is populated
        menuMediaLink.setValue('');
        menuMediaType.setValue('');
      }
    });

    // Listen for changes to menuMediaLink
    menuMediaLink.valueChanges.subscribe(value => {
      if (value) {
        // Clear menu header when media link is populated
        menuHeader.setValue('');
        this.updateHeaderRequirement();
      } else {
        // Clear any errors if field is empty
        menuMediaType.setErrors(null);
      }
    });

    // Listen for changes to menuMediaType
    menuMediaType.valueChanges.subscribe(() => {
      this.updateHeaderRequirement();
    });
  }

  private updateHeaderRequirement(): void {
  const menuMediaLink = this.richLinkForm.get('menuMediaLink');
  const menuMediaType = this.richLinkForm.get('menuMediaType');

  // If there's a media link but no media type selected
  if (menuMediaLink.value && (!menuMediaType.value || menuMediaType.value === '')) {
    menuMediaType.setErrors({ required: 'Media Type is required when a Media Header link is provided' });
  } else {
    // Only clear the specific error we set, not any other validation errors
    const currentErrors = menuMediaType.errors;
    if (currentErrors) {
      delete currentErrors.required;
      menuMediaType.setErrors(Object.keys(currentErrors).length ? currentErrors : null);
    }
  }
}

  get getStepData(): {} {
    const richLink = new RichLink();
    const rawValue = this.richLinkForm.getRawValue();
    richLink.setMenu(rawValue);
    const nodeData = richLink.nodeData;
    nodeData['next'] = rawValue.next;

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.richLinkForm.markAllAsTouched();
    return this.richLinkForm.valid;
  }

  public previewTypeChanged(event: MatButtonToggleGroup): void {
    this.richLinkForm.get('previewType').setValue(event.value);
    this.updateValidators(event.value);
  }

  setImage(event, form) {
    form.get('image').setValue(event);
  }

  private updateValidators(previewType: string): void {
    const videoUrl = this.richLinkForm.get('videoUrl');
    const videoMimeType = this.richLinkForm.get('videoMimeType');

    if (previewType === 'VIDEO') {
      videoUrl.setValidators([required('Video URL')]);
      videoMimeType.setValidators([required('Video MIME Type')]);
    } else {
      videoUrl.clearValidators();
      videoMimeType.clearValidators();
    }

    videoUrl.updateValueAndValidity();
    videoMimeType.updateValueAndValidity();
  }

  public isBodyEmpty(): boolean {
    const body = this.richLinkForm.get('body')?.value;
    return body === undefined || body === null || body === '';
  }
}
